import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Spinner, Alert } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { apiGet } from '../../API/Service/apiClient';
import { decrypt, encrypt } from '../../MIS/encryption';
import { getImageUrl } from '../../MIS/Global';
import ProductCardOne from '../GlobalComponent/ProductCardOne';
import { FaThLarge, FaTh } from 'react-icons/fa';

const MainProductCatalogue = () => {
  const navigate = useNavigate();
  const { mpid } = useParams();
  const [catalogueData, setCatalogueData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // State to manage mobile grid view per category (default: 1 card per row)
  const [gridModes, setGridModes] = useState({});
    
  useEffect(() => {
    const fetchCatalogue = async () => {
      try {
        setLoading(true);
        let id = await decrypt(mpid);
        const response = await apiGet("sub-product", { action: 'tree', mpid: id });
        setCatalogueData(response.data);
      } catch (err) {
        setError('An error occurred while fetching the catalogue.');
      } finally {
        setLoading(false);
      }
    };

    if (mpid) {
      fetchCatalogue();
    }
  }, [mpid]);

  if (loading) {
    return (
      <Container className="text-center py-5">
        <Spinner animation="border" variant="primary" />
        <p className="text-muted mt-2 small">Loading catalogue...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="py-4">
        <Alert variant="danger" className="py-2 small">{error}</Alert>
      </Container>
    );
  }

  const getExtension = (mimeType) => {
    switch (mimeType) {
      case 'image/jpeg': return 'jpg';
      case 'image/png': return 'png';
      case 'image/gif': return 'gif';
      default: return 'jpg';
    }
  };

  const handleShare = async (product) => {
    try {      
      if (!navigator.canShare) {
        alert("Sharing is not supported in your browser.");
        return;
      }
  
      const response = await fetch(getImageUrl(`${product?.img}`));
      const blob = await response.blob();
      const ext = getExtension(blob.type);
      const file = new File([blob], `product.${ext}`, { type: blob.type });
  
      let path = `/tbk/${encrypt(product.id)}`;
      if (navigator.canShare({ files: [file] })) {
        await navigator.share({
          files: [file],
          title: `${product?.name || "Awesome Product-1"}`,
          text: `Check out this products!`,
          url: `https://teeblanka.com${path}`,
        });
      } else {
        alert("Your device does not support file sharing.");
      }
    } catch (error) {
      // console.error("Error sharing:", error);      
    }
  };
    
  const handelDownload = (element, mainTitle = "") => {
    navigate("/catalogue-download", {
      state: {
        title: {
          main: mainTitle,
          sub: element?.name,
          subSub: ''
        },
        categoryId: element?.id,
        isMargin: true
      }
    });
  };

  const toggleGridMode = (categoryId) => {
    setGridModes(prev => ({
      ...prev,
      [categoryId]: prev[categoryId] === 2 ? 1 : 2
    }));
  };

  return (
    <Container className="py-3">
      {catalogueData.map((category) => {
        // Default to 1 card per row on mobile if not set
        const mobileCols = gridModes[category.id] !== undefined ? gridModes[category.id] : 1;

        return (
          <div key={category.id} className="mb-4">
            
            {/* Category / Main Title with Toggle Icon on Right End (Mobile Only) */}
            <div className="border-bottom pb-2 mb-3 d-flex align-items-center justify-content-between">
              <h5 className="fw-bold text-dark m-0 fs-6">{category.name}</h5>
              <button 
                className="btn p-1 border-0 bg-transparent text-dark d-md-none shadow-none"
                onClick={() => toggleGridMode(category.id)}
                title="Toggle View"
              >
                {mobileCols === 1 ? <FaThLarge size={16} /> : <FaTh size={16} />}
              </button>
            </div>

            {/* Main Products Loop */}
            {category.main_products && category.main_products.map((mainProd) => (
              <div key={mainProd.id} className="mb-3">
                
                {/* Sub Title */}
                <div className="d-flex align-items-center mb-2">
                  <span className="badge bg-secondary me-2 px-2 py-1" style={{ fontSize: '0.75rem' }}>Main</span>
                  <h6 className="text-secondary fw-semibold m-0 fs-6">{mainProd.name}</h6>
                </div>

                {/* Sub Products Grid (Responsive & Compact Cards) */}
                <Row xs={mobileCols} sm={3} md={4} lg={4} className="g-2">
                  {mainProd.sub_products && mainProd.sub_products.map((subProd) => (
                    <Col 
                      key={subProd.id} 
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        navigate(`/tbk/${encrypt(subProd?.id)}`);                    
                      }}
                    >
                      <ProductCardOne
                        subProd={{
                          ...subProd,
                          img: getImageUrl(subProd.img)
                        }}
                        onClick={() => {
                          // navigate(`/tbk/${encrypt(subProd?.id)}`);
                        }}
                        onShare={handleShare}
                        onDownload={(element) => handelDownload(element, mainProd.name)}
                      />
                    </Col>
                  ))}
                </Row>

              </div>
            ))}

          </div>
        );
      })}
    </Container>
  );
};

export default MainProductCatalogue;